export default __webpack_public_path__ + "static/media/beef.ba72b169.svg";